var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "60%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("sys-select-big-occupation-area", {
                          attrs: {
                            model: _vm.innerModel.big_occupation_area_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.big_occupation_area_id,
                            label: "Grande Área*",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.innerModel,
                                "big_occupation_area_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("sys-select-occupation-area", {
                          attrs: {
                            model: _vm.innerModel.occupation_area_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.occupation_area_id,
                            "big-occupation-area-id":
                              _vm.innerModel.big_occupation_area_id,
                            label: "Área*",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.innerModel,
                                "occupation_area_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("sys-select-discipline", {
                          attrs: {
                            model: _vm.innerModel.discipline_id,
                            data: _vm.innerModel.discipline,
                            error:
                              _vm.errors.discipline_id && _vm.errors.length > 0,
                            errors: _vm.errors.discipline_id,
                            label: "Unidade Curricular*",
                            "item-text": "full_name",
                            "auto-complete": "",
                            filterOfferItems: "",
                            occupationAreaId: _vm.innerModel.occupation_area_id,
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.innerModel,
                                "discipline_id",
                                $event
                              )
                            },
                            "update:data": function ($event) {
                              return _vm.$set(
                                _vm.innerModel,
                                "discipline",
                                $event
                              )
                            },
                            change: function ($event) {
                              return _vm.changeInputs($event, "discipline")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("sys-select-partner-company", {
                          attrs: {
                            model: _vm.innerModel.companies,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.companies,
                            label: "Empresas*",
                            multiple: "",
                            "auto-complete": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.innerModel,
                                "companies",
                                $event
                              )
                            },
                            input: function ($event) {
                              return _vm.changeInputs($event, "companies")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            inset: "",
                            "error-messages": _vm.errors.name,
                            label: "Nome*",
                          },
                          model: {
                            value: _vm.innerModel.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.innerModel, "name", $$v)
                            },
                            expression: "innerModel.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "2" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper":
                              "Se a parceria for local, obrigatório informar marca e campus",
                            inset: "",
                            label: "Local",
                          },
                          model: {
                            value: _vm.innerModel.is_local,
                            callback: function ($$v) {
                              _vm.$set(_vm.innerModel, "is_local", $$v)
                            },
                            expression: "innerModel.is_local",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "5" } },
                      [
                        _c("sys-select-brand", {
                          attrs: {
                            model: _vm.innerModel.brand_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.brand_id,
                            label: "Marca",
                            clearable: "",
                            disabled: !_vm.innerModel.is_local,
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.innerModel,
                                "brand_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "5" } },
                      [
                        _c("sys-select-campus", {
                          attrs: {
                            model: _vm.innerModel.campus_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.campus_id,
                            "brand-id": _vm.innerModel.brand_id,
                            label: "Campus",
                            clearable: "",
                            disabled: !_vm.innerModel.is_local,
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.innerModel,
                                "campus_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("sys-select-user", {
                          attrs: {
                            model: _vm.innerModel.user_id_focal,
                            data: _vm.innerModel.user,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.user_id_focal,
                            label: "Usuário Focal",
                            autoComplete: "",
                            clearable: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.innerModel,
                                "user_id_focal",
                                $event
                              )
                            },
                            "update:data": function ($event) {
                              return _vm.$set(_vm.innerModel, "user", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "2" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            inset: "",
                            "error-messages": _vm.errors.code,
                            label: "Código",
                          },
                          model: {
                            value: _vm.innerModel.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.innerModel, "code", $$v)
                            },
                            expression: "innerModel.code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper":
                              "Cases / Desafios reais, sem interação síncrona com a empresa",
                            inset: "",
                            label: "Atemporal",
                          },
                          model: {
                            value: _vm.innerModel.timeless,
                            callback: function ($$v) {
                              _vm.$set(_vm.innerModel, "timeless", $$v)
                            },
                            expression: "innerModel.timeless",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("s-switch", {
                          attrs: { inset: "", label: "Parceria Ativa" },
                          model: {
                            value: _vm.innerModel.active,
                            callback: function ($$v) {
                              _vm.$set(_vm.innerModel, "active", $$v)
                            },
                            expression: "innerModel.active",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-textarea", {
                          attrs: {
                            error: !!_vm.errors.description,
                            "error-messages": _vm.errors.description,
                            label: "Descrição",
                            counter: 255,
                            rows: "2",
                            rules: [
                              (v) =>
                                !v ||
                                v.length <= 255 ||
                                "Máximo de 255 caracteres atingido",
                            ],
                            outlined: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.innerModel.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.innerModel, "description", $$v)
                            },
                            expression: "innerModel.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }